import {useState,useEffect} from 'react'
import axios from 'axios';
import ReadIcon from "../../../assets/read-icon.png";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const IndependentResearcherRealWorldProblems = () => {
    const [activeTab, setActiveTab] = useState("post");
    const handleTabSwitch = (tab) => setActiveTab(tab);
    const [feedOpportunities,setFeedOpportunities] = useState([]);
      console.log("The feed opportunities are:", feedOpportunities);
      useEffect(()=>{
           const fetchFeedOpportunities = async () =>{
                  try {
                    const response = await axios.get( `${BASE_URL}/marketplace/researcher/opportunity/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          'x-api-key': process.env.REACT_APP_X_API_KEY,
        },
      })
      setFeedOpportunities(response.data);
                  } catch (error) {
                    console.error('Error fetching feed opportunities:', error);
                  }
           }
           fetchFeedOpportunities()
      },[])
  return (
    <div className=" flex flex-col gap-4 flex-1 w-full">
          <section className="
    w-full
    rounded-2xl border border-gray-200
    bg-white
    p-6
    shadow-sm
    transition-all duration-200
    hover:shadow-md
    hover:border-gray-300
  ">
  <div className="flex items-center gap-3 p-4 bg-[#e8f0f7] rounded-xl mb-6">
  <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
    <svg
      className="w-5 h-5 text-[#0f6abf]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
      />
    </svg>
  </div>
  <div className="flex-1 min-w-0">
  <div className="flex items-center gap-2 flex-wrap">
    <div className="text-sm font-semibold text-gray-900 break-words">
      Researcher Opportunities
    </div>
    <div className="text-xs text-gray-500 break-words">
      University ↔ Industry
    </div>
  </div>
</div>

</div>
{/* <div className="flex bg-gray-100 rounded-xl p-1 mb-6">

  <div
    className={`flex-1 flex items-center justify-center gap-2 py-3 px-4 text-sm font-medium cursor-pointer rounded-lg transition-all duration-200 ${
      activeTab === "post"
        ? "bg-white text-[#0f6abf] shadow-sm"
        : "text-gray-500 hover:text-gray-700"
    }`}
    onClick={() => handleTabSwitch("post")}
  >
    
    <span className="truncate">Publication / Update</span>
  </div>

 
  <div
    className={`flex-1 flex items-center justify-center gap-2 py-3 px-4 text-sm font-medium cursor-pointer rounded-lg transition-all duration-200 ${
      activeTab === "job"
        ? "bg-white text-[#0f6abf] shadow-sm"
        : "text-gray-500 hover:text-gray-700"
    }`}
    onClick={() => handleTabSwitch("job")}
  >
    <span className="truncate">Hiring / Position</span>
  </div>
</div> */}

{
  feedOpportunities.map((p, i) => (
    <div
      key={i}
      className="bg-gray-50 border border-gray-200 rounded-xl p-4 mb-4 cursor-pointer hover:border-[#0f6abf] transition-colors"
    >
      <div className="opp-header mb-4">
                  {/* First Row: Badge and Profile */}
                  <div className="flex items-center justify-between mb-3">
                    {/* Left: Badge */}
                    <div className="bg-[#e8f0f7] border border-[#0f6abf] text-[#0f6abf] text-xs font-semibold inline-block rounded-lg py-1 px-3">
                      {/* {p.post_type === "job" ? "Job" : "Post"} */}
                      Opportunity
                    </div>

                    {/* Right: Profile Section */}
                    <div
                      className="flex items-center gap-2 cursor-pointer hover:opacity-80 transition-opacity"
                      // onClick={(e) => {
                      //   e.stopPropagation();
                      //   if (p.user?.profile_id) {
                      //     navigate(`/user-profile/${p.user.profile_id}`);
                      //   }
                      // }}
                    >
                      {p.profile_data?.profile_picture && (
                        <img
                          src={p.profile_data.profile_picture}
                          alt={p.profile_data?.name || "User"}
                          className="w-8 h-8 rounded-full object-cover border border-gray-300"
                        />
                      )}
                      {!p.profile_data?.profile_picture && (
                        <div className="w-8 h-8 rounded-full bg-[#0f6abf] flex items-center justify-center text-white text-xs font-semibold">
                          {(p.profile_data?.name || "U").charAt(0).toUpperCase()}
                        </div>
                      )}
                    </div>
                  </div>
 <div className="p-3 border border-gray-200  cursor-pointer transition-all duration-200 hover:shadow-md">

  <div className="flex flex-wrap gap-2">
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {p?.domain}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-blue-50 text-blue-600 border border-blue-100">
      {p?.collaboration}
    </span>
    
    {/* <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {publication?.topic_of_interest}
    </span> */}
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {p?.maturity}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-green-50 text-green-600 border border-green-100">
      {p?.visibility}
    </span>
  </div>
</div>
  <div className="w-full mt-4">
                      {/* Media Preview */}
              {p.publication_type === "image" && (
                <img
                  src={p.file}
                  alt={p.name}
                  className="w-full h-48 object-cover"
                />
              )}
              {p.publication_type === "pdf" && (
                <iframe
                  src={`${p.file}#toolbar=0`}
                  title={p.name}
                  className="w-full h-48"
                />
              )}
              {(p.publication_type === "doc" || p.type === "docx") && (
                <iframe
                  src={`https://docs.google.com/gview?url=${encodeURIComponent(
                    p.file
                  )}&embedded=true`}
                  title={p.name}
                  className="w-full h-48"
                />
              )}
              {p.publication_type === "video" && (
                <video
                  src={p.file}
                  controls
                  className="w-full h-48 object-cover"
                />
              )}
              {p.publication_type === "audio" && (
                <div className="w-full h-48 flex items-center justify-center bg-gray-100">
                  <audio src={p.file} controls className="w-full px-4" />
                </div>
              )}
                </div>
                  {/* Second Row: Reads and Date */}
                  {/* <div className="flex items-center justify-between">
                   
                    <div className="flex items-center gap-1 text-gray-600">
                      <img className="w-4 h-4" src={ReadIcon} alt="Read Icon" />
                      <span className="text-xs font-medium">{p.reads ?? 0}</span>
                    </div>

                   
                    <div className="text-xs text-gray-500 whitespace-nowrap">
                      {new Date(p.created_at).toLocaleDateString()}
                    </div>
                  </div> */}
                </div>
    </div>
  ))
}
  </section>
    </div>
  )
}

export default IndependentResearcherRealWorldProblems